import { Component, Input, OnInit } from '@angular/core';
import { Result, StartProjectLogResult, StartProjectTableAction, TableCode } from 'app/models';
import { StartProjectDetailService, StartProjectService } from 'app/services';

@Component({
  selector: 'app-project-history',
  templateUrl: './project-history.component.html',
  styleUrls: ['./project-history.component.scss']
})
export class ProjectHistoryComponent implements OnInit {
  public result = new Result();
  public startProjectLogs = new Array<StartProjectLogResult>();
  public tableCode = TableCode;
  public tableAction = StartProjectTableAction;

  isBusy = false;

  @Input()
  public mode = 'Detail';

  @Input()
  public set id(value: number) {
    if (this.isBusy === false && value !== 0) {
      this.startProjectLogs = new Array<StartProjectLogResult>();
      this.isBusy = true;
      if (this.mode === 'Detail') {
        this.startProjectDetailServicece.getStartProjectDetailHistory(value).then(result => {
          this.isBusy = false;

          if (result.success === true) {
            this.startProjectLogs = result.data;
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      } else {
        this.startProjectService.getStartProjectHistory(value).then(result => {
          this.isBusy = false;

          if (result.success === true) {
            this.startProjectLogs = result.data;
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      }
    }
  }

  constructor(
    private startProjectService: StartProjectService,
    private startProjectDetailServicece: StartProjectDetailService
  ) { }

  ngOnInit(): void {
  }

}
